import { useTranslation } from 'react-i18next';
import ReportingDashboardSection, {
    SectionItem,
    SectionProps,
} from './ReportingDashboardSection';
import { useSelector } from '../../../../../store/hooks';
import { GridItemSpans } from '../../../../../controls/ResponsiveGrid/ResponsiveGridItem';
import CustomerCountsTile from '../tiles/CustomerCountsTile/CustomerCountsTile';

const itemSpans: GridItemSpans = {
    tabletSpan: 4,
} as const;

const CustomerUpdatesSection: React.FC<SectionProps> = ({ className }) => {
    const { t } = useTranslation();

    const { previousRange, currentRange } = useSelector(
        (x) => x.reportingDashboard
    );

    return previousRange && currentRange ? (
        <ReportingDashboardSection className={className}>
            <>
                <SectionItem {...itemSpans}>
                    <CustomerCountsTile
                        title={t('ReportingDashboard_MishandledBaggage')}
                        previousCounts={
                            previousRange.customerUpdates.mishandledBaggage
                        }
                        currentCounts={
                            currentRange.customerUpdates.mishandledBaggage
                        }
                    />
                </SectionItem>
                <SectionItem {...itemSpans}>
                    <CustomerCountsTile
                        title={t('ReportingDashboard_MisconnectedCustomers')}
                        previousCounts={
                            previousRange.customerUpdates.misconnectedCustomers
                        }
                        currentCounts={
                            currentRange.customerUpdates.misconnectedCustomers
                        }
                    />
                </SectionItem>
                <SectionItem {...itemSpans}>
                    <CustomerCountsTile
                        title={t('ReportingDashboard_CustomerMessages')}
                        previousCounts={
                            previousRange.customerUpdates.customerMessages
                        }
                        currentCounts={
                            currentRange.customerUpdates.customerMessages
                        }
                    />
                </SectionItem>
            </>
        </ReportingDashboardSection>
    ) : null;
};

export default CustomerUpdatesSection;
